// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"564fb46e","394":"e74a1b3e","426":"fa78abe2","438":"95a0a20f","721":"3ffc3a7a","781":"7540c5f7","977":"eff54e9b"}[chunkId] + ".chunk.css";
};